import { deleteCookie, setCookie } from "cookies-next";
import { useEffect } from "react";
import { HOST_BASE_PATH } from "rivals/services/base";
import useGetCurrentUser from "rivals/services/getCurrentUser/useGetCurrentUser";
import useGetSiteFromLocation from "rivals/services/getSiteFromLocation/useGetSiteFromLocation";
import {
  RIVALS_NOTIFICATIONS_COOKIE,
  RIVALS_NOTIFICATIONS_COOKIE_MAX_AGE
} from "rivals/shared/constants";
import { NotificationPermissionStatus } from "rivals/shared/hooks/useNotificationManager/types";

/**
 * This hook checks if the user has browser notifications enabled for their primary site. If so set the notifications cookie to
 * determine whether to show the push notifications banner across subdomains. If the user has not granted notifications for their
 * primary site, delete the cookie.
 */
export default function useUpdateNotificationCookie(): void {
  const { data: site } = useGetSiteFromLocation();
  const { data: user } = useGetCurrentUser();

  useEffect(() => {
    if (user?.user) {
      const isPrimarySite = site?.id === user.user.primarySite?.id;
      const isNotificationPermissionGranted =
        "Notification" in window &&
        Notification.permission === NotificationPermissionStatus.GRANTED;

      if (isPrimarySite && isNotificationPermissionGranted && site?.enablePwa) {
        setCookie(RIVALS_NOTIFICATIONS_COOKIE, true, {
          domain: HOST_BASE_PATH,
          httpOnly: false,
          maxAge: RIVALS_NOTIFICATIONS_COOKIE_MAX_AGE,
          sameSite: "lax",
          secure: true
        });
      }

      if (isPrimarySite && !isNotificationPermissionGranted) {
        deleteCookie(RIVALS_NOTIFICATIONS_COOKIE, {
          domain: HOST_BASE_PATH
        });
      }
    }
  }, [site, user]);
}
